<div class="modal-header">
    <h4 class="modal-title">Add funds to your investment wallet</h4>
    <h4 class="modal-sub-title"> Your money is safe in finzy’s <strong class="black">escrow account</strong>, here are the account
        details.</h4>
</div>

<div class="modal-body1">
    <h4 class="minimum-balance-text"> You can start investing with a minimum of
        ₹<strong style="color: #000;">{{fundAllocationMinimumAmount}}</strong></h4>
    <h4 class="body-title">You can top-up your wallet by choosing an online payment method</h4>
    <div class="modal-add-money row">
        <form name="form" (keydown.enter)="$event.preventDefault()"
            (ngSubmit)="topupAmountForm.form.valid && onAddMoneyClick(topupAmount)" #topupAmountForm="ngForm">
            <span class="enter-amount-txt">Enter Amount:</span>
            <input class="topup-amount-input" [(ngModel)]="topupAmount" name="topupAmount" type="number"
                onKeyPress="if(this.value.length==10) return false;" placeholder="5,00,000">
            <span>
                <button class="add-fund-btn float-md-right" type="submit" mat-flat-button
                    [disabled]="!isFormValid(topupAmountForm.valid)"> Add Funds to Wallet
                </button>
            </span>
        </form>
    </div>
    <span class="finzy-red" *ngIf="topupAmount <= 0">Please enter the valid amount</span>
    <div class="row">
        <p class="section-break"> <span class="mid-text"> OR </span> </p>
    </div>
    <div class="row">
        <h4 class="body-title1">You can top-up your wallet by <span style="font-weight: bolder;">
                transferring funds</span>
            to this bank account</h4>
    </div>
    <div class="row">
        <table class="table">
            <tbody>
                <tr>
                    <td class="table-left">Account Name</td>
                    <td class="table-right">Bridge Fintech Solutions Pvt Ltd</td>
                </tr>
                <tr>
                    <td class="table-left">Bank</td>
                    <td class="table-right">ICICI Bank</td>
                </tr>
                <tr>
                    <td class="table-left">Virtual Account Number</td>
                    <td class="table-right">
                        <div class="col-md-6 p-0 m-0">
                            {{virtualAccountNumber}}
                        </div>
                        <div class="col-md-6 p-0 m-0">
                            <a class="virtial-acc-sub-text" role="button"
                                (click)="onClickVirtualAccountDiscriptionOpen()">How does this work?</a>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="isVirtualAccountDiscriptionOpen" id="virtualAccountDiscription">
                    <td colspan="2" class="virtial-acc-discription">
                        <h5 role="button" class="virtial-acc-discription-title"
                            (click)="onClickVirtualAccountDiscriptionClose()">
                            How virtual account work?</h5>
                        <div class="virtial-acc-discription-detail">
                            You can transfer money to your finzy wallet via the unique Virtual Account Number assigned
                            to
                            your finzy investment account. This works like any other beneficiary account.
                        </div>
                        <div class="virtial-acc-discription-detail">
                            To add money to your finzy wallet -
                        </div>
                        <ol class="col-12 virtial-acc-discription-detail">
                            <li> Add the Virtual Account Number assigned to you as a beneficiary in your bank account
                            </li>
                            <ul>
                                <li> Payee Account Name is "Bridge Fintech Solutions Pvt Ltd"</li>

                                <li> Payee Account Number is your unique Virtual Account ID displayed on the dashboard
                                </li>
                            </ul>
                            <li> Make a transfer to the Virtual Account (using NEFT/IMPS/RTGS)</li>
                            <li> Once the funds are credited to the finzy Escrow account, we will automatically update
                                your wallet to
                                reflect the same and you can start investing!
                            </li>
                        </ol>
                        <div class="virtial-acc-discription-detail add-space">
                            Note: Some banks might not allow adding Virtual Account IDs as a new beneficiary on their
                            mobile app. In such a case, you might have to login using the web version of the bank to add
                            the beneficiary For more information on Virtual Account, please check our FAQs.
                            <button class="back-btn float-right"
                                (click)="onClickVirtualAccountDiscriptionClose()">Close</button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-left">Account type</td>
                    <td class="table-right">Current Account</td>
                </tr>
                <tr>
                    <td class="table-left ifsc-code">IFSC code</td>
                    <td class="table-right ifsc-number">ICIC0000104</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>